'use strict';

import {PANELMANAGER_SAVE_PANEL} from '../../constants';
import {AppDispatch, StoreState, Thunk} from '~/frontend/src/store';
import {
    panelClasses,
    PanelType,
    PanelClass
} from '~/frontend/src/components/base/page/PageTabPanel/definitions';
import {getPanelProps} from '~/frontend/src/components/base/page/PageTabPanel/utilities';

export type SavePanelAction = {
    type : typeof PANELMANAGER_SAVE_PANEL,
    panelKey : string
};

/**
 * @memberOf! Actions
 *
 * @param {String} panelKey
 */
const savePanel = ( panelKey : string ) : Thunk<Promise<boolean>> => async ( dispatch : AppDispatch, getState : () => StoreState ) : Promise<boolean> => {
    let retVal : boolean = false;

    dispatch( {
        type: PANELMANAGER_SAVE_PANEL,
        panelKey
    } );

    const panelProps          = getPanelProps( panelKey )?.panelProps,
          panelType           = panelProps?.panelType,
          PanelComponentClass = panelType ? panelClasses[ panelType as PanelType ] as unknown as PanelClass : undefined;

    // has panel a save action -> dispatch it
    if ( PanelComponentClass?.onSavePanelAction ) {
        retVal = true;

        await dispatch( PanelComponentClass.onSavePanelAction( { ...panelProps, uid: panelKey } ) );
    }

    return retVal;
}
export type SavePanel = typeof savePanel;

export default savePanel;
